"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VdbsClient = void 0;
class VdbsClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
    }
    async callVdbsDevicePlatformEndpoint(vin, softwareVersion, modGeneration) {
        const headers = {
            'Check-Software-Version': softwareVersion.toString(),
            'Check-Mod-Generation': modGeneration.toString(),
        };
        const response = await this.authService.get(`myvw-vdbs-${this.stage}`, `v1/vehicles/${vin}/device-platform`, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getDevicePlatform(vin) {
        return this.callDevicePlatformEndpoint(vin, false);
    }
    async getDevicePlatformWithOnlineDevices(vin) {
        return this.callDevicePlatformEndpoint(vin, true);
    }
    async getModGeneration(vin) {
        return this.callDevicePlatformEndpoint(vin, false);
    }
    async callDevicePlatformEndpoint(vin, includeOnlineDevices) {
        const headers = {
            'Check-Software-Version': includeOnlineDevices.toString(),
            'Check-Mod-Generation': true.toString(),
        };
        let response;
        try {
            response = await this.authService.get(`myvw-vdbs-${this.stage}`, `v1/vehicles/${vin}/device-platform`, headers);
        }
        catch (e) {
            return undefined;
        }
        if (!response.ok) {
            return undefined;
        }
        return await response.json();
    }
}
exports.VdbsClient = VdbsClient;
//# sourceMappingURL=VdbsClient.js.map